import React, { Component } from "react";
import { Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import {WorkItemListingActionAgent, EvaluatedTemplateActionagent, WorkItemListingActionAuditor, WorkItemListingActionCount, closeModalPopUp, ResetSubmitted,ScoreCalculation,
  WorkItemListingActionAuditorCompleted, showAgentQARelated, WorkItemListingActionAgentCompleted, EvaluatedTemplateAction} from './WorklistingAction';
import {Tabs, Tab} from 'react-bootstrap';
import {TokenValidation} from '../Dashboard/UserActions';
import Inbox from './Inbox';
import QACompleted from './QACompleted';
import AgentInbox from './AgentInbox';
import AgentCompleted from "./AgentCompleted";
import ShowModalPopUp from '../ShowModalPopUp';
import _ from 'lodash';

class WorkListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  componentDidMount(){
    this.props.TokenValidation()  
  }
  loadTabContent = (prop) => {
    this.setState({key:prop})
  }
  ScreensComp = () =>{        
    const {auditorbox, agentbox, count, isPending, completedauditor, agentData, ScoreCalculation, completedagent, loginAction, submitted} = this.props; 
    const{key} = this.state
    if(!_.isEmpty(loginAction)){
    let moduleAccess = _.find(loginAction.modulescreens, {"moduleUId": "INBOX"})
    let returnObj =[]
    _.map(moduleAccess.screens, (obj) =>{ 
        if(obj.screenUId === "AGENT_COMPLETED_AUDITS"){ 
          returnObj.push(<Tab eventKey="AGENT_COMPLETED_AUDITS" title="AUDIT WITH FEEDBACK" key={4}>
          <AgentCompleted data={completedagent} action={this.props}  CompletedAuditsView={true} loginUserName={loginAction.userName} ScoreCalculation={ScoreCalculation} />
        </Tab>)}
        if(obj.screenUId === "INBOX_AGENT"){ 
          returnObj.push(<Tab eventKey="INBOX_AGENT" title="INBOX AGENT" key={3}>
          <AgentInbox data={agentbox} loginUserName={loginAction.userName} CompletedAuditsView={true} submitted={submitted} ScoreCalculation={ScoreCalculation}
           action={this.props}  /> 
          </Tab>)}
        if(obj.screenUId === "INBOX_QA"){ 
          returnObj.push(<Tab eventKey="INBOX_QA" title="INBOX QA" key={1}>
          <Inbox auditorbox={auditorbox} workCount={count} action={this.props} isPending={isPending} submitted={submitted} agentData={agentData}
        loginUserName={loginAction.userName} isSpinner={this.props.isSpinner}/> 
       </Tab>)}
        if(obj.screenUId === "QA_COMPLETED_AUDITS"){ 
          returnObj.push(<Tab eventKey="QA_COMPLETED_AUDITS" title="AUDIT COMPLETED"  key={2}>
          <QACompleted data={completedauditor} action={this.props} ScoreCalculation={ScoreCalculation} loginUserName={loginAction.userName}/>
        </Tab>)}
    })
    returnObj =	_.sortBy(returnObj, ['key'])
   return (<Tabs defaultActiveKey={moduleAccess.screens[0].screenUId} transition={false} activeKey={key ? key : returnObj[0].props.eventKey} unmountOnExit={true}
   id="noanim-tab-example" onSelect={(eventKey)=>this.loadTabContent(eventKey)}>
   {returnObj}</Tabs>)
    }
  } 
  
  render() {
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    }
    return (
     <div  className={(style) ? 'user' : "userSmall"}>
      <div style={{padding:0}} className={(this.props.isSpinner === true) ? 'disabled': ''}>
     {this.props.isPending ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>Loading...</p> : null}
     {(this.props.isSpinner === true) ? <div className='wrapperSpinner'><span className='spinnerRound'></span></div> : null}        
      {(this.props.showerror === true) ?
      <ShowModalPopUp message={this.props.errmessage} 
      falseShowModalPopUp={this.props.closeModalPopUp}/> : null} 
      {this.ScreensComp()}
     </div>
     </div>
    );
  }
}
function mapStateToProps(state){
  return{
    auditorbox: state.WorklistingReducer.auditorbox,
    agentbox: state.WorklistingReducer.agentbox,
    size: state.UserReducer.large,
    isPending:state.WorklistingReducer.isPending,
    count:state.WorklistingReducer.count,
    completedauditor:state.WorklistingReducer.completedauditor,
    completedagent:state.WorklistingReducer.completedagent,
    submitted:state.WorklistingReducer.submitted,
    loginAction: state.LoginReducer.loginAction,
    errmessage:  state.WorklistingReducer.errmessage, 
    ScoreCalculation:  state.WorklistingReducer.ScoreCalculation,
    agentData: state.WorklistingReducer.agentData, 
    showerror:  state.WorklistingReducer.showerror, 
    showModalLogin: state.UserReducer.showModalLogin,
    isSpinner:  state.WorklistingReducer.isSpinner
  }  
}
const mapDispatchToProps = (dispatch) => ({
  agentworkList: (a) =>dispatch(WorkItemListingActionAgent(a)),
  auditorworkList: (a) =>dispatch(WorkItemListingActionAuditor(a)),
  auditorworkCount: (obj) =>dispatch(WorkItemListingActionCount(obj)),  
  auditorScoreCalculation: (a) =>dispatch(ScoreCalculation(a)), 
  closeModalPopUp: () =>dispatch(closeModalPopUp()),
  auditorEvaluationSubmit : (a, b, c, d, e) =>dispatch(EvaluatedTemplateAction(a, b, c, d, e)),
  agentEvaluationSubmit : (a, b, c, d) =>dispatch(EvaluatedTemplateActionagent(a, b, c, d)),  
  auditorworkListCompleted: (a) =>dispatch(WorkItemListingActionAuditorCompleted(a)),
  agentworkListCompleted: (a) =>dispatch(WorkItemListingActionAgentCompleted(a)),
  ResetSubmitted:() =>dispatch(ResetSubmitted()),
  showAgentQARelated:(a) =>dispatch(showAgentQARelated(a)),
  TokenValidation : (a) => dispatch(TokenValidation(a))
  
})

export default connect(mapStateToProps, mapDispatchToProps)(WorkListing);
